import { useEffect, useState } from 'react';
import productService from '../services/productService';

export default function useAvailableStock(articleIds) {
    const idsKey = JSON.stringify([...new Set(articleIds.filter(Boolean))].sort());
    const [quantities, setQuantities] = useState({});
    const [error, setError] = useState(false);
    const [revision, setRevision] = useState(0);
    useEffect(() => {
        let active = true;
        setError(false);
        setQuantities({});
        const ids = JSON.parse(idsKey);
        if (ids.length) productService.availableStock(ids)
            .then(data => { if (active) setQuantities(data || {}); })
            .catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [idsKey, revision]);
    return { quantities, error, refresh: () => setRevision(value => value + 1) };
}
